import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { footerGroups, navGroups } from "../content";

export function AppShell({ children }: { children: React.ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState<string | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setOpenGroup(null);
  }, [location.pathname, location.hash]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="site-shell">
      <header className={`site-header ${scrolled ? "is-scrolled" : ""}`}>
        <div className="container header-inner">
          <Link className="brand" to="/" aria-label="ORIQ home">
            <img src="/assets/oriq-mark.png" alt="" />
            <span>ORIQ</span>
          </Link>
          <nav
            className={`desktop-nav ${menuOpen ? "is-open" : ""}`}
            aria-label="Primary navigation"
          >
            {navGroups.map((group) => (
              <div
                className={`nav-group ${openGroup === group.label ? "is-open" : ""}`}
                key={group.label}
              >
                <button
                  className="nav-trigger"
                  onClick={() =>
                    setOpenGroup((current) =>
                      current === group.label ? null : group.label,
                    )
                  }
                  aria-expanded={openGroup === group.label}
                >
                  {group.label}
                  <span aria-hidden="true">⌄</span>
                </button>
                <div className="nav-menu">
                  {group.items.map((item) => (
                    <Link to={item.href} key={item.label}>
                      <strong>{item.label}</strong>
                      {item.description && <small>{item.description}</small>}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </nav>
          <div className="header-actions">
            <Link className="text-link header-whitepaper" to="/whitepaper">
              Read Whitepaper
            </Link>
            <Link className="button button-small" to="/contact">
              Build with ORIQ <span aria-hidden="true">↗</span>
            </Link>
          </div>
          <button
            className="menu-toggle"
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <Link className="footer-brand" to="/">
              <img src="/assets/oriq-mark.png" alt="" />
              <span>ORIQ</span>
            </Link>
            <p>Trusted Agent Infrastructure</p>
          </div>
          <Link className="footer-contact" to="/contact">
            Build with ORIQ <span aria-hidden="true">↗</span>
          </Link>
        </div>
        <div className="footer-grid">
          {footerGroups.map((group) => (
            <div key={group.label}>
              <h3>{group.label}</h3>
              {group.items.map((item) => (
                <Link to={item.href} key={item.label}>
                  {item.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <span>© 2026 ORIQ</span>
          <span className="footer-legal">
            <a href="mailto:info@oriqai.com">info@oriqai.com</a>
            <NavLink to="/about#privacy">Privacy</NavLink>
            <NavLink to="/about#terms">Terms</NavLink>
          </span>
        </div>
      </div>
    </footer>
  );
}
